import React from 'react';

interface Event {
  id: number;
  title: string;
  description: string;
  date: string;
  time: string;
  recurring?: 'daily' | 'weekly' | 'monthly';
}

interface EventScheduleProps {
  events: Event[];
  className?: string;
}

const EventSchedule: React.FC<EventScheduleProps> = ({ 
  events,
  className = ''
}) => {
  if (!events || events.length === 0) {
    return null;
  }

  return (
    <div className={`bg-gray-800 rounded-lg shadow-lg p-6 ${className}`}>
      <h3 className="text-xl font-bold mb-4">Upcoming Events</h3>
      
      <div className="space-y-4">
        {events.map(event => (
          <div key={event.id} className="border border-gray-700 rounded-lg p-4 hover:bg-gray-750 transition">
            <div className="flex justify-between items-start">
              <div>
                <h4 className="font-bold text-lg">{event.title}</h4>
                <p className="text-gray-400 mt-1">{event.description}</p>
              </div>
              <div className="text-right">
                <div className="font-medium">{event.date}</div>
                <div className="text-gray-400">{event.time}</div>
                {event.recurring && (
                  <div className="text-xs text-blue-400 mt-1">
                    {event.recurring.charAt(0).toUpperCase() + event.recurring.slice(1)}
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EventSchedule;